// Module
var code = `<div class="onboarding_modal__dialog" ng-transclude role="dialog" aria-modal="true" aria-labelledby="onboarding-dialog-title" tabindex="-1"></div>`;
// Exports
export default code;